import { Button } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import PageHeader from '@components/shared/PageHeader';

export function NewSessionPageHeader() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleBackToSessions = () => {
    navigate('/sessions');
  };

  const handleContactSupport = () => {
    window.open('mailto:support@become-hub.com', '_blank');
  };

  return (
    <PageHeader
      title={t('new_session_title', 'Crea Nuova Sessione')}
      subtitle={t(
        'new_session_description',
        'Configura una nuova sessione VR seguendo i passaggi'
      )}
      breadcrumbs={[
        {
          label: t('sessions', 'Torna alla lista sessioni'),
          onClick: handleBackToSessions,
        },
      ]}
      backUrl='/sessions'
      actions={
        <Button variant='light' onClick={handleContactSupport}>
          Contatta supporto
        </Button>
      }
    />
  );
}
